import accessAsset from "./AssetControl";
import accessAuth from "./AuthControl"
import accessDashboard from "./DashboardControl";
import accessMaintenance from "./MaintenanceControl";
import accessMaster from "./MasterControl";
import accessReport from "./Report";
import accessUserManagement from "./UserManagementControl";
import accessSuperAdmin from "./SuperAdminControl";
import accessSettings from "./SettingsControl";
import accessCustomerFreelancerLink from "./CustomerFreelancerLinkControl";
import accessProduction from "./ProductionControl";

const RoutesMap = {
    ...accessAuth,
    ...accessDashboard,
    ...accessMaster,
    ...accessAsset,
    ...accessMaintenance,
    ...accessReport,
    ...accessUserManagement,
    ...accessSuperAdmin,
    ...accessSettings,
    ...accessCustomerFreelancerLink,
    ...accessProduction,
}

export default RoutesMap;